import useSWR from 'swr'
import { organizationsApi } from '@/lib/api'
import type { Organization } from '@/lib/api'
import { useAuth } from '@/lib/config/auth-provider'

const SWR_KEY = 'organizations/current'

interface UseCurrentOrgReturn {
  org: Organization | null
  isLoading: boolean
  error: Error | undefined
  isPersonal: boolean
  isOwner: boolean
  isAdmin: boolean
  canInvite: boolean
}

export function useCurrentOrg(): UseCurrentOrgReturn {
  const { isAuthenticated } = useAuth()
  // Gate SWR on auth state so the request never fires for unauthenticated
  // share/public-page visitors, where a 401 would otherwise hard-redirect.
  const { data, isLoading, error } = useSWR<Organization | null>(
    isAuthenticated ? SWR_KEY : null,
    () => organizationsApi.getCurrent(),
    { revalidateOnFocus: false },
  )

  const org = data ?? null
  const isPersonal = org?.type === 'personal'
  const isOwner = org?.orgRole === 'owner'
  const isAdmin = org?.orgRole === 'owner' || org?.orgRole === 'admin'
  const canInvite = !isPersonal && isAdmin

  return { org, isLoading, error, isPersonal, isOwner, isAdmin, canInvite }
}

export { SWR_KEY as ORG_SWR_KEY }
